import { cn } from "@/lib/utils";

interface PortalToggleProps {
  active: "admin" | "customer";
  onToggle: (value: "admin" | "customer") => void;
}

export function PortalToggle({ active, onToggle }: PortalToggleProps) {
  return (
    <div className="flex bg-sc-glass border border-sc-glass-border rounded-[10px] p-[3px]">
      {(["admin", "customer"] as const).map((type) => (
        <button
          key={type}
          type="button"
          onClick={() => onToggle(type)}
          className={cn(
            "flex-1 py-1.5 rounded-lg text-[10.5px] font-semibold capitalize font-display transition-all",
            active === type
              ? "bg-sc-green text-white"
              : "bg-transparent text-sc-text-muted",
          )}
        >
          {type}
        </button>
      ))}
    </div>
  );
}
